<template lang="pug">
  v-container(scrollable max-width="700" persistent )
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card.pa-0.elevation-0
      v-card-text.pa-0
        v-tabs(
          v-model="tab"
          show-arrows
          next-icon="fas fa-arrow-right"
          prev-icon="fas fa-arrow-left")
          v-tab Texty
          v-tab {{ $t('smartLinkPage.customers') }}
        v-tabs-items(v-model="tab")
          v-tab-item
            v-card-text.pa-0()
              v-form()
                v-row.ma-0.mt-2
                  v-col.pa-0(cols="12")
                    v-textarea(:label=" $t('smartLinkPage.description')"  outlined v-model="description" )
                  v-col.pa-0(cols="12")
                    v-text-field(:label=" $t('smartLinkPage.descriptionForCustomer')" outlined dense v-model="descriptionForCustomer" )
                  v-col.pa-0(cols="12")
                    v-text-field(:label=" $t('smartLinkPage.descriptionForBoarderGroup')" outlined dense v-model="descriptionForBoarderGroup" )
          v-tab-item
            v-card.elevation-0.pa-0.pt-3
              v-card-text.pa-0
                v-row.ma-0.pt-4
                  v-col.pa-0.pl-4(cols="12")
                    v-checkbox.mt-0(:label=" $t('smartLinkPage.enableCustomerSettings')" on-icon="fas fa-check-square" off-icon="far fa-square" v-model="enabledCustomer" hide-details @change="onEnabledCustomerChange")
                v-row.ma-0.pt-4
                  v-col.pa-0(cols="12")
                    v-treeview.tree.pa-0(
                      on-icon="fas fa-check-square"
                      off-icon="far fa-square"
                      indeterminate-icon="fas fa-minus-square"
                      v-model="selection"
                      :items="treeData"
                      :style="{'margin-left': '2px'}"
                      selectable
                      return-object
                      open-all
                      :item-disabled="isDisabled"
                      )
</template>

<script lang="ts">
import Vue, {nextTick} from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import SmartLink from "@/model/SmartLink";
import Customer from "@/model/customer/Customer";
import BoarderGroup from "@/model/boarder/BoarderGroup";

@Component({
  components: {
  }
})
export default class SmartLinkSettings extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: false}) readonly selectedSmartLink!: SmartLink
  @Prop({type: Array, required: false}) readonly customers!: Customer[]
  @Prop({type: Array, required: false}) readonly boarderGroupList!: BoarderGroup[]

  private tab: number | null = null
  private selection: any[] = []
  private treeData: any[] =[]
  private descriptionForCustomer: string = ''
  private descriptionForBoarderGroup: string = ''
  private enabledCustomer: boolean = true
  private enabledBoarderGroup: boolean = true
  private description: string = ''
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''

  @Watch('selection')
  watchSelection(newVal: any[]): void {
    if(newVal.length < 1) {
      this.showSnackBar = true
      this.snackBarColor = 'orange'
      this.snackBarMessage = this.$t('smartLinkPage.requiredMessage').toString()
    }
    let data: string[] = []
      newVal.forEach((item: any) => {
        if(!data.includes(item.parentData.data.iri)){
          data.push(item.parentData.data.iri)
        }
        data.push(item.data.iri)
      })

      this.$emit('selectionChange',data)
  }

  @Watch('description')
  watchDescription(newVal: string): void {
    this.$emit('description',newVal)
  }

  @Watch('descriptionForCustomer')
  watchDescriptionForCustomer(newVal: string): void {
      this.$emit('descriptionForCustomer',newVal)
  }

  get isDisabled (): string {
    let treeDisabled: string = ''
    if(this.enabledCustomer) {
      treeDisabled = 'locked'
    } else {
      treeDisabled = ''
    }
    return treeDisabled
  }

  onEnabledCustomerChange(newVal: boolean): void {
    if(newVal) {
      const newSelection: any[] = []
      this.treeData.forEach((item: any) => {
        item.children.forEach((i: any) => {
          i.locked = true
          newSelection.push(i)
        })
        item.locked = true
        //newSelection.push(item)
      })

      nextTick(()=> {
        this.selection = [...newSelection]
      })
    } else {
      this.treeData.forEach((item: any) => {
        item.children.forEach((i: any) => {
          i.locked = false
        })
        item.locked = false
      })
      nextTick(() => {
        this.selection = []
      })

    }
    this.$emit('enabledCustomer',newVal)
  }

  @Watch('descriptionForBoarderGroup')
  watchDescriptionForBoarderGroup(newVal: string): void {
      this.$emit('descriptionForBoarderGroup',newVal)
  }

  onSelectionChange (item: any[]): void {
    if(!this.enabledCustomer) {
      this.selection = item
      if(item.length < 1) {
        this.showSnackBar = true
        this.snackBarColor = 'orange'
        this.snackBarMessage = this.$t('smartLinkPage.requiredMessage').toString()
      }
    } else {
      this.selection = [...this.selection]
    }

  }

  onCloseButtonClick (): void{
    this.$emit('close')
  }

  mounted(): void {
    if(this.selectedSmartLink && this.selectedSmartLink.configuration) {
      this.description = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].description ? this.selectedSmartLink.configuration[0].description : ''
      this.descriptionForCustomer = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].customers_label ? this.selectedSmartLink.configuration[0].customers_label : ''
      this.descriptionForBoarderGroup = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].boarder_group_label ? this.selectedSmartLink.configuration[0].boarder_group_label : ''
      if(this.selectedSmartLink.configuration.length == 0) {
        this.selection = this.treeData
      }
    }

    this.treeData = this.customers.map((item: Customer, index: number) => {
      let childrenData: BoarderGroup[] = this.boarderGroupList.filter((i: BoarderGroup) => i.customer && i.customer.id === item.id)
      return {
        id: index,
        name: item.name,
        data: item,
        isParent: true,
        locked: this.enabledCustomer,
        children: childrenData.map((i: BoarderGroup, idx: number) => {
          return {
            id: index + '-' + idx,
            name: i.name,
            data: i,
            isParent: false,
            parentData: null,
            locked: this.enabledCustomer
          }
        })
      }
    })
    this.treeData.forEach((item: any) => {
      item.children.forEach((i: any) => {
        i.parentData = item
        if(this.selectedSmartLink && this.selectedSmartLink.configuration && this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].enabled_boarder_group && this.selectedSmartLink.configuration[0].enabled_boarder_group.length == 0) {
          this.selection.push(i)
          this.enabledCustomer = true
        } else if(this.selectedSmartLink && this.selectedSmartLink.configuration && this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].enabled_boarder_group ) {
          if(this.selectedSmartLink.configuration[0].enabled_boarder_group.includes(i.data.iri)) {
            this.selection.push(i)
            this.enabledCustomer = false
            item.locked = false
            i.locked = false
          }
        } else {
          this.selection.push(i)
          this.enabledCustomer = true
          item.locked = true
          i.locked = true
        }
      })
    })
  }
}
</script>

<style lang="stylus" scoped>
.tree
  >>> .v-treeview-node__toggle
    width 0px !important
</style>
